import { render, staticRenderFns } from "./ProducersTableName.vue?vue&type=template&id=4f841405&"
import script from "./ProducersTableName.vue?vue&type=script&lang=js&"
export * from "./ProducersTableName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports